
import React from 'react';
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Wand, TimerReset } from "lucide-react";

interface PreferencesFormProps {
  preferredDays: string[];
  togglePreferredDay: (day: string) => void;
  preferredTimeRange: string;
  setPreferredTimeRange: (value: string) => void;
  handleGetSuggestions: () => void;
  handleResetForm: () => void;
  isLoading: boolean;
  isFormValid: boolean;
}

const PreferencesForm: React.FC<PreferencesFormProps> = ({
  preferredDays,
  togglePreferredDay,
  preferredTimeRange,
  setPreferredTimeRange,
  handleGetSuggestions,
  handleResetForm,
  isLoading,
  isFormValid
}) => {
  const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>Preferred Days</Label>
        <div className="flex flex-wrap gap-2">
          {weekdays.map(day => (
            <Badge 
              key={day} 
              variant={preferredDays.includes(day) ? 'default' : 'outline'}
              className="cursor-pointer"
              onClick={() => togglePreferredDay(day)}
            >
              {day.substring(0, 3)}
            </Badge>
          ))}
        </div>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="time-range">Preferred Time Range</Label>
        <Select value={preferredTimeRange} onValueChange={setPreferredTimeRange}>
          <SelectTrigger>
            <SelectValue placeholder="Any time" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="any">Any time</SelectItem>
            <SelectItem value="morning">Morning (8am - 12pm)</SelectItem>
            <SelectItem value="afternoon">Afternoon (12pm - 5pm)</SelectItem>
            <SelectItem value="evening">Evening (5pm - 9pm)</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="pt-4">
        <Button 
          onClick={handleGetSuggestions} 
          disabled={isLoading || !isFormValid} 
          className="w-full mt-4 gap-2"
        >
          <Wand className="h-4 w-4" />
          {isLoading ? 'Generating Suggestions...' : 'Get AI Suggestions'}
        </Button>
        
        <Button
          variant="outline"
          className="w-full mt-2 gap-2"
          onClick={handleResetForm}
        >
          <TimerReset className="h-4 w-4" />
          Reset Form
        </Button>
      </div>
    </div>
  );
};

export default PreferencesForm;
